import { apiHost } from 'Helpers/apiurl'
import Request from 'Services/request';

export default function uploadImage(fileType, file) {
     return Request.create(`${ apiHost }/media/upload?${ fileType }`, file);
}